
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[[...hscene]]",
      function () {
        return require("private-next-pages/home/[[...hscene]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/[[...hscene]]"])
      });
    }
  